<template>
  <div>
    <mia-car-edit-labelled-text
      v-if="car.item_exchange === 'Y' && !car.exchange_for"
      class="mt-2"
      label="Inzahlungnahme für"
    >
      <a
        :href="`/cars/${car.item_exchange_of}`"
        target="_blank"
      >
        {{ car.item_exchange_of_fin }}
      </a>
    </mia-car-edit-labelled-text>
    <mia-car-edit-labelled-text
      v-else-if="car.exchange_for"
      class="mt-2"
      label="Inzahlungnahme von"
    >
      <a
        :href="`/cars/${car.exchange_for.id}`"
        target="_blank"
      >
        {{ car.exchange_for.item_fin }}
      </a>
    </mia-car-edit-labelled-text>
    <mia-car-edit-labelled-text
      v-else
      class="mt-2"
      label="Inzahlungnahme"
    >
      <button
        type="button"
        class="text-sm italic transition-colors duration-150 text-orange-mia hover:text-orange-mia-dark ease-out-fast focus:outline-none"
        @click="showExchangeModal = true"
      >
        Fahrzeug verknüpfen
      </button>
    </mia-car-edit-labelled-text>

    <mia-exchange-modal
      v-if="showExchangeModal"
      :car-id="car.id"
      @closed="showExchangeModal = false"
      @done="onExchangeAssigned"
    />
  </div>
</template>

<script>
import ExchangeModal from '@/components/cars/edit/ExchangeModal.vue'
import LabelledText from '@/components/cars/edit/LabelledText.vue'

export default {
  name: 'MiaExchangeInfo',

  components: {
    'mia-car-edit-labelled-text': LabelledText,
    'mia-exchange-modal': ExchangeModal
  },

  data: () => ({
    showExchangeModal: false
  }),

  computed: {
    car: {
      get() {
        return this.$store.state.car.car
      },

      set(car) {
        this.$store.commit('setCar', car)
      }
    }
  },

  methods: {
    async onExchangeAssigned() {
      this.showExchangeModal = false
      this.$emit('exchange-saved')
    }
  }
}
</script>
